import { render, staticRenderFns } from "./relectureAni.vue?vue&type=template&id=6d977ef4&scoped=true"
import script from "./relectureAni.vue?vue&type=script&lang=js"
export * from "./relectureAni.vue?vue&type=script&lang=js"
import style0 from "./relectureAni.vue?vue&type=style&index=0&id=6d977ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d977ef4",
  null
  
)

export default component.exports